import { FC } from 'react';
import classNames from 'classnames';

import Button from './Button';

import { ColumnHeaderType, ColumnOrder } from '../types/tables';
import ChevronRight from '../svgs/ChevronRight';
import { sortOptions as patientManagementSortOptions } from '../pages/PatientManagement/helpers';

const TableHeader: FC<{
  column: ColumnHeaderType;
  useAltHeaderName?: boolean;
  isFirstColumn?: boolean;
  isLastColumn?: boolean;
  sortOptions?: Record<string, ColumnOrder>;
  handleHeaderClick?: (column: ColumnHeaderType) => void;
  className?: string;
  previousColumnClicked?: ColumnHeaderType | null | undefined;
  columnOrder?: ColumnOrder;
  style?: React.CSSProperties;
}> = ({
  column,
  sortOptions = patientManagementSortOptions,
  isFirstColumn = false,
  useAltHeaderName = false,
  className = '',
  columnOrder,
  previousColumnClicked,
  handleHeaderClick,
  style,
}) => {
  const isSortable = column?.isSortable || false;

  const isSortOrderInColumn = Boolean(
    column.columnOrders?.find((order) => order.name === columnOrder?.name),
  );

  const isSortOrderNewestCreated =
    columnOrder?.name === sortOptions.newestCreated.name;

  let iconProps = {};
  if (isSortable && isSortOrderInColumn && !isSortOrderNewestCreated) {
    iconProps = {
      IconComponent: ChevronRight,
      iconClassName: classNames(
        'h-[16px] w-[16px] rotate-90',
        columnOrder?.isAscending
          ? 'hover:text-neutral-125 rotate-90'
          : columnOrder?.isDescending
          ? '-rotate-90 hover:text-neutral-125'
          : 'invisible',
      ),
    };
  }

  const textAlign = style?.textAlign || 'left';
  const textAlignClass = textAlign === 'right' ? 'text-right' : 'text-left';

  return (
    <th
      scope="col"
      className={classNames(
        textAlignClass,
        'text-small-caption font-medium text-neutral-150',
        isFirstColumn && 'pl-0',
      )}
      style={style}
    >
      {isSortable ? (
        <Button
          onClick={() => handleHeaderClick && handleHeaderClick(column)}
          title={column.headerName}
          {...iconProps}
          noFocus
          className={classNames(
            textAlignClass,
            'text-small-caption font-medium text-neutral-150 hover:text-neutral-125',
            className,
          )}
          theme="secondary"
          size="extra-small"
          noBackground
          noOutline
        />
      ) : (
        <div
          className={classNames(
            textAlignClass,
            'text-small-caption font-medium text-neutral-150',
            className,
          )}
        >
          {useAltHeaderName && column.headerNameAlt
            ? column.headerNameAlt
            : column.headerName}
        </div>
      )}
    </th>
  );
};

export default TableHeader;
